import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import {
	BATCH_DEBIT_HISTORY,
	ORDER_TYPES,
	MAIN_TAB,
	SUB_TAB,
	PAYMENT_METHODS,
	preserveSearchParams
} from "@icoach/batchPayment/staticData";
import { mergeQueryToUrl } from "@util/utils";
import { ACCOUNT_BOOK_BULK_DEBIT_URL } from "@icoach/router/routerPath";
import MembershipBatchPaymentBatchDebitHistory from "./MembershipBatchPaymentBatchDebitHistory";
import MembershipBatchPaymentCurrentDebitList from "./MembershipBatchPaymentCurrentDebitList";
import MembershipBatchPaymentExemptedDebitList from "./MembershipBatchPaymentExemptedDebitList";
import MembershipBatchPaymentOverdueDebitList from "./MembershipBatchPaymentOverdueDebitList";
import { BatchPaymentMainTabSwitcher } from "@icoach/batchPayment/component";

const MembershipBatchPaymentPage = ({ searchParams, ...rest }) => {
	const activeTab = searchParams[MAIN_TAB] || BATCH_DEBIT_HISTORY;

	const tabsConfigs = useMemo(() => {
		return {
			[BATCH_DEBIT_HISTORY]: {
				label: "扣款結果列表",
				value: BATCH_DEBIT_HISTORY,
				to: mergeQueryToUrl(
					ACCOUNT_BOOK_BULK_DEBIT_URL,
					preserveSearchParams(searchParams, {
						[MAIN_TAB]: BATCH_DEBIT_HISTORY
					})
				),
				buttonComponent: Link,
				listComponent: <MembershipBatchPaymentBatchDebitHistory />
			},
			[ORDER_TYPES.CURRENT]: {
				label: "扣款名單",
				value: ORDER_TYPES.CURRENT,
				to: mergeQueryToUrl(
					ACCOUNT_BOOK_BULK_DEBIT_URL,
					preserveSearchParams(searchParams, {
						[MAIN_TAB]: ORDER_TYPES.CURRENT,
						[SUB_TAB]: PAYMENT_METHODS.CREDIT
					})
				),
				buttonComponent: Link,
				listComponent: <MembershipBatchPaymentCurrentDebitList />
			},
			[ORDER_TYPES.EXEMPTED]: {
				label: "免扣款名單",
				value: ORDER_TYPES.EXEMPTED,
				to: mergeQueryToUrl(
					ACCOUNT_BOOK_BULK_DEBIT_URL,
					preserveSearchParams(searchParams, {
						[MAIN_TAB]: ORDER_TYPES.EXEMPTED
					})
				),
				buttonComponent: Link,
				listComponent: <MembershipBatchPaymentExemptedDebitList />
			},
			[ORDER_TYPES.OVERDUE]: {
				label: "未扣款名單",
				value: ORDER_TYPES.OVERDUE,
				to: mergeQueryToUrl(
					ACCOUNT_BOOK_BULK_DEBIT_URL,
					preserveSearchParams(searchParams, {
						[MAIN_TAB]: ORDER_TYPES.OVERDUE,
						[SUB_TAB]: PAYMENT_METHODS.CREDIT
					})
				),
				buttonComponent: Link,
				listComponent: <MembershipBatchPaymentOverdueDebitList />
			}
		};
	}, [searchParams]);

	return <BatchPaymentMainTabSwitcher sourceData={tabsConfigs} activeTab={activeTab} {...rest} />;
};

export default MembershipBatchPaymentPage;
